<div class="page-head page-head--custom">
    <app-back (onBack)="onBack()"></app-back>
    <h1 class="title title--size-l text--center">Custom Network fee</h1>
</div>
<div class="custom-gas-price page-row page-content">
    <div class="top">
        <div class="data-row">
            <p class="text text--color-secondary text--size-s">
                {{ "COMMON.BASE-BALANCE" | translate }}
            </p>
            <p class="text text--bold font-roboto-mono">
                {{ baseBalance | number : "1.2-2" }} {{ baseUnit }}
            </p>
            <p class="text text--color-secondary text--size-s font-roboto-mono">
                {{ fiatBalance | number : "1.2-2" }} {{ fiatCurrency }}
            </p>
        </div>
        <div class="data-row">
            <app-transaction-fee [fee-oracle]="feeOracle" [symbol]="feeUnit" [selected-fee]="defaultFee"
                [baseUnit]="baseUnit" (onChange)="onFeeChange($event)"></app-transaction-fee>
        </div>
        <div class="data-row row-grid">
            <div>
                <p class="text text--color-secondary text--size-s">
                    Custom Fee
                </p>
                <input #inputEl autocomplete="off" type="number" min="0" step="1"
                    class="input text--size-large font-roboto-mono" id="amount" [min]="0" [value]="default" />
                <p class="text text--color-secondary text--size-s font-roboto-mono">
                    ~ {{ fiatCustomFee }} {{ fiatCurrency }}
                </p>
                <p class="text text--color-secondary text--size-s font-roboto-mono">
                    ~ {{ getCoinPrice() | number : ".0-8" }} {{ baseUnit }}
                </p>
            </div>
            <div>
                <p class="text text--bold text--size-large">
                    {{ feeUnit | uppercase }}
                </p>
            </div>
        </div>
    </div>
    <div class="wrapper--center page-content--padding-top">
        <button class="btn wide-btn" (click)="submit()" [disabled]="isProcessing | async">
            Set Network Fee
        </button>
    </div>
</div>
